<div class="row g-3 align-items-end mb-3">
  <div class="col-md-3">
    <label class="form-label" for="auditoriaEmpregador">Empregador</label>
    <select
      id="auditoriaEmpregador"
      class="form-select"
      name="auditoriaEmpregador"
      [ngModel]="empregadorSelecionado"
      (ngModelChange)="empregadorSelecionadoChange.emit($event)">
      <option value="">Todos permitidos</option>
      <option *ngFor="let item of empregadores" [value]="item.id">{{ item.razaoSocial }}</option>
    </select>
  </div>
  <div class="col-md-2">
    <label class="form-label" for="auditoriaDataInicial">Data inicial</label>
    <input
      id="auditoriaDataInicial"
      class="form-control"
      type="date"
      name="auditoriaDataInicial"
      [ngModel]="dataInicial"
      (ngModelChange)="dataInicialChange.emit($event)">
  </div>
  <div class="col-md-2">
    <label class="form-label" for="auditoriaDataFinal">Data final</label>
    <input
      id="auditoriaDataFinal"
      class="form-control"
      type="date"
      name="auditoriaDataFinal"
      [ngModel]="dataFinal"
      (ngModelChange)="dataFinalChange.emit($event)">
  </div>
  <div class="col-md-3">
    <label class="form-label" for="auditoriaTipo">Tipo de registro</label>
    <select
      id="auditoriaTipo"
      class="form-select"
      name="auditoriaTipo"
      [ngModel]="tipoSelecionado"
      (ngModelChange)="tipoSelecionadoChange.emit($event)">
      <option value="">Todos</option>
      <option *ngFor="let tipo of tiposAuditoria" [value]="tipo.valor">{{ tipo.rotulo }}</option>
    </select>
  </div>
  <div class="col-md-2">
    <label class="form-label" for="auditoriaStatus">Status</label>
    <select
      id="auditoriaStatus"
      class="form-select"
      name="auditoriaStatus"
      [ngModel]="statusSelecionado"
      (ngModelChange)="statusSelecionadoChange.emit($event)">
      <option *ngFor="let status of statusAuditoria" [value]="status.valor">{{ status.rotulo }}</option>
    </select>
  </div>
  <div class="col-md-2">
    <label class="form-label" for="auditoriaLimite">Por pagina</label>
    <select
      id="auditoriaLimite"
      class="form-select"
      name="auditoriaLimite"
      [ngModel]="limite"
      (ngModelChange)="limiteChange.emit(+$event)">
      <option [ngValue]="25">25 eventos</option>
      <option [ngValue]="50">50 eventos</option>
      <option [ngValue]="100">100 eventos</option>
    </select>
  </div>
  <div class="col-md-4">
    <label class="form-label">Servidor</label>
    <app-busca-pesquisavel
      nomeCampo="buscaFuncionarioAuditoria"
      rotuloBuscar="Pesquisar servidor"
      placeholder="Todos os servidores"
      [termo]="buscaFuncionario"
      [itens]="funcionariosFiltrados"
      [rotuloItem]="rotuloFuncionario"
      [detalheItem]="detalheFuncionario"
      (termoChange)="buscaFuncionarioChange.emit($event)"
      (buscar)="abrirModalFuncionario.emit()"
      (selecionar)="selecionarFuncionario.emit($event)">
    </app-busca-pesquisavel>
  </div>
</div>
